webpackJsonp([35783957827783],{

/***/ 864:
/***/ (function(module, exports) {

	"use strict";
	
	var timeago = function() {
	
	  var o = {
	    second: 1000,
	    minute: 60 * 1000,
	    hour: 60 * 1000 * 60,
	    day: 24 * 60 * 1000 * 60,
	    week: 7 * 24 * 60 * 1000 * 60,
	    month: 30 * 24 * 60 * 1000 * 60,
	    year: 365 * 24 * 60 * 1000 * 60
	  };
	  var obj = {};
	
	  obj.ago = function(nd, s) {
	    var r = Math.round,
	        dir = ' ago',
	      pl = function(v, n) {
	        return (s === undefined) ? n + ' ' + v + (n > 1 ? 's' : '') + dir : n + v.substring(0, 1)
	      },
	      ts = Date.now() - new Date(nd).getTime(),
	      ii;
	    if( ts < 0 )
	    {
	      ts *= -1;
	      dir = ' from now';
	    }
	    for (var i in o) {
	      if (r(ts) < o[i]) return pl(ii || 'm', r(ts / (o[ii] || 1)))
	      ii = i;
	    }
	    return pl(i, r(ts / o[i]));
	  }
	
	  obj.today = function() {
	    var now = new Date();
	    var Weekday = new Array("Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday");
	    var Month = new Array("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December");
	    return Weekday[now.getDay()] + ", " + Month[now.getMonth()] + " " + now.getDate() + ", " + now.getFullYear();
	  }
	
	  obj.timefriendly = function(s) {
	    var t = s.match(/(\d).([a-z]*?)s?$/);
	    return t[1] * eval(o[t[2]]);
	  }
	
	  obj.mintoread = function(text, altcmt, wpm) {
	    var m = Math.round(text.split(' ').length / (wpm || 200));
	    return (m || '< 1') + (altcmt || ' min to read');
	  }
	
	  return obj;
	}
	
	if (typeof module !== 'undefined' && module.exports)
	  module.exports = timeago();


/***/ }),

/***/ 972:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    position: relative;\n    max-width: ", ";\n    margin: 0 auto;\n  "], ["\n    position: relative;\n    max-width: ", ";\n    margin: 0 auto;\n  "]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    max-height: 400px;\n    // margin: 0 auto;\n    // max-width: ", ";\n  "], ["\n    max-height: 400px;\n    // margin: 0 auto;\n    // max-width: ", ";\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    // background: linear-gradient(217deg, rgba(255,0,0,.8), rgba(255,0,0,0) 70.71%),\n    //             linear-gradient(127deg, rgba(0,255,0,.8), rgba(0,255,0,0) 70.71%),\n    //             linear-gradient(336deg, rgba(0,0,255,.8), rgba(0,0,255,0) 70.71%);\n    background: linear-gradient(\n        135deg,\n        rgba(255, 194, 0, 0.4) 0,\n        rgba(255, 194, 0, 0) 50%,\n        rgba(255, 194, 0, 0) 100%\n      ),\n      linear-gradient(\n        45deg,\n        rgba(40, 0, 215, 0) 0,\n        rgba(40, 0, 215, 0) 50%,\n        rgba(40, 0, 215, 0.4) 100%\n      ),\n      linear-gradient(transparent 5%, rgba(0, 0, 0, 0.8) 100%);\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: flex;\n    justify-content: flex-end;\n    align-items: flex-start;\n    flex-direction: column;\n    padding: 2em;\n  "], ["\n    position: absolute;\n    // background: linear-gradient(217deg, rgba(255,0,0,.8), rgba(255,0,0,0) 70.71%),\n    //             linear-gradient(127deg, rgba(0,255,0,.8), rgba(0,255,0,0) 70.71%),\n    //             linear-gradient(336deg, rgba(0,0,255,.8), rgba(0,0,255,0) 70.71%);\n    background: linear-gradient(\n        135deg,\n        rgba(255, 194, 0, 0.4) 0,\n        rgba(255, 194, 0, 0) 50%,\n        rgba(255, 194, 0, 0) 100%\n      ),\n      linear-gradient(\n        45deg,\n        rgba(40, 0, 215, 0) 0,\n        rgba(40, 0, 215, 0) 50%,\n        rgba(40, 0, 215, 0.4) 100%\n      ),\n      linear-gradient(transparent 5%, rgba(0, 0, 0, 0.8) 100%);\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: flex;\n    justify-content: flex-end;\n    align-items: flex-start;\n    flex-direction: column;\n    padding: 2em;\n  "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n    font-size: 3em;\n    line-height: 1.2em;\n    color: white;\n    text-decoration: none;\n    text-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);\n    transition: all 200ms;\n    border-bottom: 3px solid transparent;\n    &:hover {\n      color: ", ";\n      border-bottom: 3px solid ", ";\n    }\n  "], ["\n    font-size: 3em;\n    line-height: 1.2em;\n    color: white;\n    text-decoration: none;\n    text-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);\n    transition: all 200ms;\n    border-bottom: 3px solid transparent;\n    &:hover {\n      color: ", ";\n      border-bottom: 3px solid ", ";\n    }\n  "]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n    font-size: 1.5em;\n    line-height: 2em;\n    color: white;\n    text-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);\n  "], ["\n    font-size: 1.5em;\n    line-height: 2em;\n    color: white;\n    text-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);\n  "]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(36);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(30);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactHelmet = __webpack_require__(39);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _siteConfig = __webpack_require__(42);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _timeAgo = __webpack_require__(864);
	
	var _timeAgo2 = _interopRequireDefault(_timeAgo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// import withRoot from '../withRoot';
	// import graphpaperBackground from '../images/graph_paper.png'
	
	// const styles = theme => ({
	//   root: {
	//     textAlign: 'center',
	//     paddingTop: theme.spacing.unit * 20,
	//   },
	// });
	
	var Index = function Index(_ref) {
	  var data = _ref.data;
	
	  var posts = data.allContentfulPost.edges;
	  var newCampaign = data.allContentfulCampaign.edges[0].node;
	
	  var Hero = _styledComponents2.default.section(_templateObject, function (props) {
	    return props.theme.sizes.maxWidth;
	  });
	
	  var CampaignCover = (0, _styledComponents2.default)(_gatsbyImage2.default)(_templateObject2, function (props) {
	    return props.theme.sizes.maxWidth;
	  });
	
	  var CampaignCoverOverlay = _styledComponents2.default.div(_templateObject3);
	
	  var CampaignTitle = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject4, function (props) {
	    return props.theme.colors.highlight;
	  }, function (props) {
	    return props.theme.colors.highlight;
	  });
	
	  var CampaignInfo = _styledComponents2.default.div(_templateObject5);
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      Hero,
	      null,
	      _react2.default.createElement(CampaignCover, {
	        sizes: newCampaign.heroImage.sizes,
	        backgroundColor: "#EEEEEE"
	      }),
	      _react2.default.createElement(
	        CampaignCoverOverlay,
	        null,
	        _react2.default.createElement(
	          CampaignTitle,
	          { to: "/campaigns/" + newCampaign.slug },
	          newCampaign.title
	        ),
	        _react2.default.createElement(
	          CampaignInfo,
	          null,
	          "Published ",
	          _timeAgo2.default.ago(new Date(newCampaign.publishDate))
	        )
	      )
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";
	
	exports.default = Index;
	// export default withRoot(withStyles(styles)(Index));

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-88f8e0ec2ef16ba3de74.js